window.theme = window.theme || {};
/* Shopify variant badge state is rendered by snippets/variant-labels.liquid. */
theme.VariantLabels = (function() {
  var galleryStates = new WeakMap();

  function apply(scope, labels) {
    if (!scope) return;
    labels = labels || {};
    scope.querySelectorAll('[data-variant-labels]').forEach(function(wrapper) {
      var main = wrapper.querySelector('[data-variant-main-label]');
      var upper = wrapper.querySelector('[data-variant-upper-label]');
      var upperWrapper = wrapper.querySelector('[data-variant-upper-wrapper]');
      if (main) {
        main.textContent = labels.mainText || '';
        main.className = 'grid-product__tag grid-product__tag--' + (labels.mainType || 'custom');
        main.classList.toggle('hide', !labels.mainText);
      }
      if (upper) {
        upper.textContent = labels.upperText || '';
        upper.style.backgroundColor = labels.upperBackground || '';
        upper.style.color = labels.upperColor || '';
      }
      if (upperWrapper) upperWrapper.classList.toggle('hide', !labels.upperText);
    });
  }

  function syncGallery(scope, variantId) {
    if (!scope) return;
    var script = scope.querySelector('[data-product-variant-labels]');
    if (!script) return;
    var variants = galleryStates.get(script);
    if (!variants) {
      try {
        variants = Object.create(null);
        JSON.parse(script.textContent).variants.forEach(function(variant) {
          variants[String(variant.id)] = variant.labels;
        });
        galleryStates.set(script, variants);
      } catch (error) {
        return;
      }
    }
    apply(scope, variants[String(variantId)]);
  }

  return { apply: apply, syncGallery: syncGallery };
})();

/* Keep quick-view forms aligned with the SKU displayed by the triggering card. */
theme.selectVariantInForm = function(container, variantId) {
  if (!container || !variantId) return;
  var script = container.querySelector('[data-variant-json]');
  var select = container.querySelector('[data-product-select]');
  if (!script || !select) return;
  var variant;
  try {
    variant = JSON.parse(script.value || script.textContent).find(function(candidate) {
      return String(candidate.id) === String(variantId);
    });
  } catch (error) {
    return;
  }
  if (!variant) return;
  select.value = String(variant.id);
  var selectedInput;
  container.querySelectorAll('[data-variant-input]').forEach(function(input) {
    if (!input.dataset.index) return;
    var value = variant[input.dataset.index];
    if (input.type === 'radio' || input.type === 'checkbox') {
      input.checked = input.value === value;
      if (input.checked) selectedInput = input;
    } else {
      input.value = value;
      selectedInput = input;
    }
  });
  if (selectedInput) {
    // Theme's user-click handler clears other options for disabled inputs.
    // A programmatic complete selection must preserve all options of an unavailable SKU.
    var wasUnavailable = selectedInput.classList.contains('disabled');
    if (wasUnavailable) selectedInput.classList.toggle('disabled', false);
    selectedInput.dispatchEvent(new Event('change', { bubbles: true }));
    if (wasUnavailable) selectedInput.classList.toggle('disabled', true);
  }
};
